import { render, staticRenderFns } from "./sendnotice.vue?vue&type=template&id=db6e4a7e&scoped=true&"
import script from "./sendnotice.vue?vue&type=script&lang=js&"
export * from "./sendnotice.vue?vue&type=script&lang=js&"
import style0 from "./sendnotice.vue?vue&type=style&index=0&id=db6e4a7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6e4a7e",
  null
  
)

export default component.exports